import { create } from "zustand";

// Accelerando ERP integration config. Per-browser, localStorage — same shape
// as the GitHub PAT store. baseUrl points at the deployed cloudflare worker
// (or http://localhost:8787 during wrangler dev); tenantId scopes every
// tool call to a single tenant's data inside that worker; apiKey is the
// Bearer token the worker requires on every non-OPTIONS request.

const STORAGE_BASE = "playground.accelerando_base_url";
const STORAGE_TENANT = "playground.accelerando_tenant_id";
const STORAGE_KEY = "playground.accelerando_api_key";

function load(key: string): string | null {
  if (typeof localStorage === "undefined") return null;
  return localStorage.getItem(key);
}

type AccelerandoState = {
  baseUrl: string | null;
  tenantId: string | null;
  apiKey: string | null;
  setBaseUrl: (url: string) => void;
  setTenantId: (id: string) => void;
  setApiKey: (key: string) => void;
  clear: () => void;
};

export const useAccelerandoStore = create<AccelerandoState>((set) => ({
  baseUrl: load(STORAGE_BASE),
  tenantId: load(STORAGE_TENANT),
  apiKey: load(STORAGE_KEY),
  setBaseUrl: (url) => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_BASE, url);
    }
    set({ baseUrl: url });
  },
  setTenantId: (id) => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_TENANT, id);
    }
    set({ tenantId: id });
  },
  setApiKey: (key) => {
    if (typeof localStorage !== "undefined") {
      localStorage.setItem(STORAGE_KEY, key);
    }
    set({ apiKey: key });
  },
  clear: () => {
    if (typeof localStorage !== "undefined") {
      localStorage.removeItem(STORAGE_BASE);
      localStorage.removeItem(STORAGE_TENANT);
      localStorage.removeItem(STORAGE_KEY);
    }
    set({ baseUrl: null, tenantId: null, apiKey: null });
  },
}));
